import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Amplify } from "aws-amplify";
import { App } from "./App.tsx";
import { AuthProvider } from "./lib/auth.tsx";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId:
        (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) ??
        "af-south-1_DFfrDbU16",
      userPoolClientId:
        (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) ??
        "6494k3a919hl4n0v52tsmmendv",
      signUpVerificationMethod: "code",
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
